import { useEffect, useState } from 'react';
import { studioApi } from '@/lib/studioApi';

let list = null;
export const guidedIds = () => (list ||= studioApi('/guided').then(d => d.items).catch(() => { list = null; return []; }));
export const useGuidedIds = () => { const [ids, setIds] = useState([]); useEffect(() => { guidedIds().then(setIds); }, []); return ids; };
export const useGuidedFor = productId => {
  const [flow, setFlow] = useState(null);
  useEffect(() => { if (!productId) return; Promise.all([guidedIds(), studioApi(`/templates?product_id=${encodeURIComponent(productId)}`).catch(() => ({ items: [] }))]).then(([ids, t]) => setFlow((t.items || []).map(i => i.id).find(id => ids.includes(id)) || null)); }, [productId]);
  return flow;
};
